export default __webpack_public_path__ + "static/media/Venturer's Gloves of the Painted Claw.edbdcd25.jpg";